import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    labelColumn: {
        display: "flex",
        flexDirection: "column",
        gap: 40,
    },
    labelSection: {
        display: "flex",
        flexDirection: "column",
        gap: 4,
    },
    label: {
        fontSize: 14,
        color: "#344054",
        fontWeight: 500,
        lineHeight: "20px",
    },
    note: {
        fontSize: 12,
        color: "#98A2B3",
        lineHeight: "18px",
        fontStyle: "italic",
    },
    reminderRow: {
        display: "flex",
        flexDirection: "column",
        gap: 4,
        marginBottom: 20,
    },
    checkboxRow: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 8,
    },
    checkboxLabel: {
        fontSize: 14,
        color: "#344054",
    },
}));
